import "./App.css";
import "./assets/css/style.css";

import { Login } from "./components/login/Login";
import { Home } from "./components/dashboard/Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ViewUser } from "./components/users/viewUser.js";
import { ViewUsers } from './components/users/viewUsers.js'
import SecuredRoute from "./util/SecuredRoute.js";
import { AppProvider } from "./util/AppContext.js";
import UnsecuredRoute from "./util/UnsecuredRoute.js";
import { PageNotFound } from "./components/Notfound.js";
import CategoryManagement from "./components/category/CategoryManagement.js";
import { ProductManagemet } from "./components/product/proudct.js";
import { ViewProductDetail } from "./components/product/productDetails.js";
import { EnquiryManagement } from "./components/bulletin/Enquiry.js";
import { OrderManagemet } from "./components/order/orders.js";
import { ViewOrderDetail } from "./components/order/orderDetails.js";
import { SettingManagement } from "./components/settings/settings.js";
import { ToastContainer } from "react-toastify";
import { TransactionManagement } from "./components/transaction/transaction.js";
import { ContactusManagemet } from "./components/contact-us/contactus.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <UnsecuredRoute><Login /></UnsecuredRoute>,
  },
  {
    path: "/login",
    element: <UnsecuredRoute><Login /></UnsecuredRoute>,
  },
  {
    path: "/category",
    element: <SecuredRoute><CategoryManagement /></SecuredRoute>,
  },
  {
    path: "/products",
    element: <SecuredRoute><ProductManagemet /></SecuredRoute>,
  },
  {
    path: "/settings",
    element: <SecuredRoute><SettingManagement /></SecuredRoute>,
  },
  {
    path: "/products/:id",
    element: <SecuredRoute><ViewProductDetail /></SecuredRoute>,
  },
  {
    path: "/orders",
    element: <SecuredRoute><OrderManagemet /></SecuredRoute>,
  },
  {
    path: "/order-detail/:id",
    element: <SecuredRoute><ViewOrderDetail /></SecuredRoute>,
  },
  {
    path: "/home",
    element: <SecuredRoute><Home /></SecuredRoute>,
  },
  {
    path: "/users",
    element: <SecuredRoute><ViewUsers /></SecuredRoute>,
  },
  {
    path: "/enquiry",
    element: <SecuredRoute><EnquiryManagement /></SecuredRoute>,
  },
  {
    path: "/transactions",
    element: <SecuredRoute><TransactionManagement /></SecuredRoute>,
  },
  {
    path: "/contact-us",
    element: <SecuredRoute><ContactusManagemet /></SecuredRoute>,
  },
  {
    path: "/users/:id",
    element: <SecuredRoute><ViewUser /></SecuredRoute>,
  },
  
 
  {
    path: "*",
    element: <PageNotFound/>,
  },
]);

function App() {
  return (
    <>
      <AppProvider>
        <RouterProvider router={router}/>
        <ToastContainer position="top-right" autoClose={3000} />
      </AppProvider>
    </>
  )
}

export default App;
